export default __webpack_public_path__ + "3c02c67bbe34cb52867cb4394607302d.png";